module.exports = __webpack_public_path__ + "static/media/mall_logo_bottom.a32a2254.png";